// extracted by mini-css-extract-plugin
export default {"actionBtn":"styles_actionBtn__-T6l6","mainBtn":"styles_mainBtn__gfLzB","actionEditBtn":"styles_actionEditBtn__ONFBf","floatingMenu":"styles_floatingMenu__7v9eW"};